<template>
  <b-modal
    id="modal-landing"
    dialog-class="base-modal"
    body-class="p-0"
    hide-header
    hide-header-close
    hide-footer
    centered
    @hidden="changeLandingModal"
  >
    <div id="event-landing">
      <img
        class="notice-landing"
        @click="goToLandingPage"
        :src="`${$s3}/img/${lang}/event/landing/new/notice.webp?${$ver}`"
        alt=""
      />
      <button class="close" @click.once="hideModal()">
        <img class="close-btn" :src="`${$s3}/img/common/event/landing/new/close.webp?${$ver}`" />
      </button>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LandingEventModal',
  computed: {
    ...mapState(['lang', 'isMobile']),
  },
  methods: {
    goToLandingPage() {
      this.$bvModal.hide('modal-landing');
      this.$router.push({ name: 'Landing' });
    },
    hideModal() {
      this.$bvModal.hide('modal-landing');
    },
    changeLandingModal() {
      // console.log('hidden');
      this.$store.commit('changeLandingModal');
    },
    getPeriodTxt(start, end) {
      return `${this.$tfDate(this.$tl(start, this.lang))} ~ ${this.$tfMonthDay(this.$tl(end, this.lang))} (${this.$tl(
        end,
        this.lang
      ).toFormat('HH:mm')})`;
    },
  },
};
</script>

<style lang="scss">
#modal-landing___BV_modal_body_ {
  background: none;
}
</style>

<style lang="scss" scoped>
.drop-event-content {
  ::v-deep {
    img {
      width: 18px;
    }
  }
}

.photo-event {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;

  img {
    aspect-ratio: 1 / 1;
  }
}

#event-landing {
  background: #f5f5f5;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  img.notice-landing {
    width: 100%;
    max-height: 80%;
    cursor: pointer;
  }
  button.close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    cursor: pointer;
    img.close-btn {
      width: 20px;
    }
  }

  .attendance {
    background: center / cover no-repeat url($s3-url + '/img/common/attendance/attendance_check_bg.svg?' + $version);
    border-radius: 8px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);

    &.event {
      background: center / cover no-repeat url($s3-url + '/img/common/attendance/background.webp?' + $version);

      .event-title {
        position: relative;
        width: 100%;
        padding-top: 28px;

        @include mobile {
          padding-top: 24px;
        }

        img.event-title-img {
          position: relative;
          display: block;
          width: 75%;
          margin: 0 auto;
          z-index: 2;
        }
        .event-title-bg {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 95%;
          z-index: 1;
        }
      }

      .modal-btn.confirm.event {
        background: #ffffff;
        color: #333333;
      }
    }
  }

  .event-body {
    text-align: center;
    color: #666666;
    padding-bottom: 10px;

    .event-title {
      font-weight: 600;
      font-size: 20px;
      color: #333333;
    }
  }
}
</style>
